import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAuth } from "@saleor/sdk";
import React from "react";
import { EasyLinkLoading } from "./View/EasyLinkLoading";
import { EasyLinkPage } from "./Page/EasyLinkPage";
export var EasyLink = function EasyLink() {
  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showLogin = _React$useState2[0],
      setShowLogin = _React$useState2[1];

  var _useAuth = useAuth(),
      isCurrentTokenValid = _useAuth.isCurrentTokenValid,
      signOut = _useAuth.signOut,
      user = _useAuth.user;

  var handleVerifyToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$isCurrentToken, isValid;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(user === null || user === void 0 ? void 0 : user.id)) {
                _context.next = 10;
                break;
              }

              window.avoidRefreshSignInToken();
              _context.next = 4;
              return isCurrentTokenValid();

            case 4:
              _yield$isCurrentToken = _context.sent;
              isValid = _yield$isCurrentToken.isValid;

              if (isValid) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return signOut();

            case 9:
              window.allowRefreshSignInToken();

            case 10:
              setShowLogin(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleVerifyToken() {
      return _ref.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    handleVerifyToken();
  }, []);
  return React.createElement(React.Fragment, null, showLogin ? React.createElement(EasyLinkLoading, {
    loading: showLogin,
    data: null
  }) : React.createElement(EasyLinkPage, null));
};